<template>
  <div class="preparetion-list">
    <div class="list-table__title">Deadline Setting List</div>
    <b-table
      striped
      hover
      fixed
      Outlined
      show-empty
      :empty-text="'No data available'"
      :items="preparetions"
      :fields="fields"
      :table-class="'list-table text-center'"
      :thead-class="'list-table__head'"
      :tbody-class="'list-table__body'"
    >
      <template #head(select)>
        <label class="checkbox">
          <input
            @change="selectAll($event)"
            type="checkbox"
            :value="pager.current"
            v-model="selectedItem"
          >
        </label>
      </template>
      <template #cell(select)="deadline">
        <label class="checkbox">
          <input
            :value="deadline.item.id"
            type="checkbox"
            v-model="selectedItem"
          >
        </label>
      </template>
      <template #cell(tutor.tutorId)="deadline">
        <router-link
          :to="{name: 'TutorDetail', params: { id: deadline.item.tutor.tutorId }}"
        >
          {{ deadline.item.tutor.tutorId }}
        </router-link>
      </template>
      <template #cell(tutor.name)="deadline">
        <router-link
          :to="{name: 'TutorDetail', params: { id: deadline.item.tutor.tutorId }}"
        >
          {{ deadline.item.tutor.name }}
        </router-link>
      </template>
    </b-table>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import { Moment } from 'moment'
import _ from 'lodash'
import { Level } from '@/store/master/types'
import { Pager } from '@/store/pager.types'

export default Vue.extend({
  data(): {
    fields: object[],
    selectedItem: string[],
    } {
    return {
      fields: [
        {
          key: 'select',
          label: 'Select',
        },
        {
          key: 'lesson.datetime',
          label: 'Lesson Date',
          formatter: (datetime: Moment): string => datetime.format('YYYY/MM/DD'),
        },
        {
          key: 'tutor.tutorId',
          label: 'Tutor ID',
        },
        {
          key: 'tutor.name',
          label: 'Tutor',
        },
        {
          key: 'lesson.period',
          label: 'Period',
        },
        {
          key: 'lesson.level',
          label: 'Level',
          formatter: (level: Level) => level?.code,
        },
        {
          key: 'lesson.section.name',
          label: 'Section name',
        },
        {
          key: 'expired',
          label: 'Preparation limit',
          formatter: (date: Moment): string => date.format('YYYY-MM-DD HH:mm'),
        },
      ],
      selectedItem: [],
    };
  },

  props: {
    preparetions: Array,
    pager: Object as PropType<Pager>,
  },
  methods: {
    selectAll(event: {target: HTMLInputElement}) {
      const deadlineIds: string[] = this.preparetions.map((deadline: any) => deadline.id)
      _.pull(this.selectedItem, ...deadlineIds)

      if (event.target.checked) {
        this.selectedItem.push(...deadlineIds)
      }
    },
  },
})
</script>

<style>
.preparetion-list .list-table .list-table__head {
  font-size: .6rem;
}

.preparetion-list .list-table .list-table__head th {
  vertical-align: middle;
}

.preparetion-list .list-table .list-table__head th label {
  margin-bottom: 0;
}

.preparetion-list .list-table .list-table__body td {
  font-size: .6rem;
  padding: 1rem;
  overflow-wrap: break-word;
}
</style>
